export namespace Url {
    
    export function isAbsolute(value: string): boolean {
        return /^https?:\/\//i.test(value);
    }

    export function isOwnDomain(value: string): boolean {
        return value.startsWith(`${location.protocol}//${location.host}`);
    }
}